var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Container, { ContainerType } from '@/models/Container';
import Vue from 'vue';
import Component from 'vue-class-component';
var RegisterComponent = /** @class */ (function (_super) {
    __extends(RegisterComponent, _super);
    function RegisterComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.email = '';
        _this.password = '';
        _this.error = '';
        return _this;
    }
    RegisterComponent.prototype.register = function () {
        var _this = this;
        this.$validator.validateAll().then(function (result) {
            if (result) {
                _this._register();
            }
        }).catch(function () {
            return false;
        });
    };
    RegisterComponent.prototype._register = function () {
        var _this = this;
        this.$dao.register(this.email, this.password).then(function (user) {
            console.log('User registered');
            _this._makeLogin(_this.email, _this.password);
        }, function (err) {
            console.log('Firebase register: ' + err.message);
            _this.error = err.message;
        });
    };
    RegisterComponent.prototype._makeLogin = function (email, password) {
        var _this = this;
        this.$dao.login(email, password).then(function (user) {
            //tworzymy domyślne kontenery
            _this.$dao.saveContainer(new Container('Szafa'));
            _this.$dao.saveContainer(new Container('Pranie', ContainerType.Dirty));
            _this.$dao.saveContainer(new Container('Wyjazd', ContainerType.Trip));
            _this.$router.push({ name: 'panel' });
        }, function (err) {
            console.log('Firebase sign in after registration: ' + err.message);
        });
    };
    RegisterComponent = __decorate([
        Component
    ], RegisterComponent);
    return RegisterComponent;
}(Vue));
export default RegisterComponent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./src/components/register/component.ts
// module id = null
// module chunks = 